export function useMember() {
  const config = useRuntimeConfig()

  function getFullname(member = {}, options = {}) {
    const firstname = member.firstname || ''
    const lastname = member.lastname || ''
    const nameOrder = options.nameOrder || 'lastname-firstname'

    if (!firstname && !lastname) return ''

    if (nameOrder === 'lastname-firstname') {
      return [lastname, firstname].filter(Boolean).join(' ')
    }

    return [firstname, lastname].filter(Boolean).join(' ')
  }

  const getPictureUrl = (member, fallbackUrl = config.public.logo) => {
    if (!member?.photo) {
      return fallbackUrl
    }

    if (member.photo.formats?.thumbnail?.url) {
      return `${config.public.strapi}${member.photo.formats.thumbnail.url}`
    }

    if (member.photo.formats?.small?.url) {
      return `${config.public.strapi}${member.photo.formats.small.url}`
    }
    if (member.photo?.url) {
      return `${config.public.strapi}${member.photo.url}`
    }

    if (member.photo.name) {
      return `${config.public.strapi}/uploads/${member.photo.name}`
    }

    return fallbackUrl
  }

  return {
    getFullname,
    getPictureUrl
  }
}
